/* cn-polish.js — v33 (26 Oct 2026)
   The gold cursor ring (#cn-cursor) is placed by theme.js on mousemove but
   starts at the top-left corner and stays wherever the pointer last left the
   window. Show it only while a real mouse is over the page. */
(function () {
  var root = document.documentElement;
  var CLS = 'cn-cursor-on';
  /* Journal tags are stored as slugs ("black-and-gold"); show them as words. Links are unchanged. */
  function untag() {
    var els = document.querySelectorAll('.article-hero__tags, .article-tags__tag, .blog-card__tags span');
    for (var i = 0; i < els.length; i++) {
      var n = els[i];
      for (var c = n.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) { c.nodeValue = c.nodeValue.replace(/(\S)-(?=\S)/g, '$1 '); }
      }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', untag); } else { untag(); }

  if (!document.getElementById('cn-cursor')) { return; }
  document.addEventListener('mousemove', function () {
    if (!root.classList.contains(CLS)) { root.classList.add(CLS); }
  }, { passive: true });
  document.addEventListener('mouseleave', function () { root.classList.remove(CLS); });
  window.addEventListener('blur', function () { root.classList.remove(CLS); });
})();
